import { deletePlanChange } from '@api/system';
import type { RootState } from '@features/redux/store';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';

export const DeletePlanChangeDialog = ({
    planId,
    open,
    onClose,
    onRefresh,
}: {
    planId: number;
    open: boolean;
    onClose: () => void;
    onRefresh: () => void;
}) => {
    const { IdToken } = useSelector((state: RootState) => state.auth);

    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        const resp = await deletePlanChange(IdToken!, planId).catch((err) => {
            return { success: false, message: err?.response?.data?.message };
        });

        if (resp.success) {
            onClose();
            onRefresh();
        }
        setLoading(false);
    };

    return (
        <Dialog open={open} onClose={() => onClose()}>
            <DialogTitle variant='h4'>Delete Plan Change</DialogTitle>

            <DialogContent sx={{ width: '500px' }}>
                <Typography>Are you sure you want to delete this plan change?</Typography>
            </DialogContent>

            <DialogActions>
                <Button sx={{ textTransform: 'none' }} onClick={() => onClose()}>
                    Cancel
                </Button>
                <Button sx={{ textTransform: 'none' }} onClick={handleDelete} disabled={loading} variant='contained'>
                    {loading ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
